import { api } from "./orgApi";

export async function getOrgUserPermissions({ organizationId } = {}) {
  const { data } = await api.get("/access/permissions", {
    params: organizationId ? { organizationId } : {},
  });
  return data;
}

export async function saveOrgUserPermissions({ organizationId, grants }) {
  const { data } = await api.put("/access/permissions", {
    organizationId,
    grants,
  });
  return data;
}
